// ── SHA-256 password hashing (Web Crypto API — aucune dépendance) ─────────────

export async function hashPassword(plain) {
  const enc = new TextEncoder().encode(plain);
  const buf = await crypto.subtle.digest('SHA-256', enc);
  return Array.from(new Uint8Array(buf))
    .map(b => b.toString(16).padStart(2, '0'))
    .join('');
}

// Un mot de passe hashé est toujours exactement 64 caractères hexadécimaux
export function isHashed(pwd) {
  return /^[0-9a-f]{64}$/.test(pwd || '');
}
